import _ from "lodash";

import { getInfectedDevices } from "../root.selectors";

export const getInfectedDeviceList = _.flow(
  getInfectedDevices,
  (infectedDevicesSlice) => infectedDevicesSlice.list
);
